module.exports = __webpack_public_path__ + "img/logo-orbitalelevadores-desktop.a39c3693.svg";